<script type="text/ecmascript-6">
    import DesignerQuestionHardwareHingeBolts from "../DesignerQuestionHardwareHingeBolts.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareHingeBolts
        ],
        props: {
            title: {
                default(){
                    return 'Hinge Bolts:';
                }
            },
        },
        computed: {
            panel_required(){
                return true;
            }
        },
    }
</script>
